import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from "react";
import FinanceExplained from "./components/finance-explained/finance-explained";
import FinanceLenders from "./components/finance-lenders/finance-lenders";
import FindACarCta from "./components/find-a-car-cta/find-a-car-cta";
import FindACar from "./components/find-a-car/find-a-car";
import HowItWorks from "./components/how-it-works/how-it-works";
import ReadyToGetCarFinance from "./components/ready-to-get-car-finance/ready-to-get-car-finance";
import TrustpilotScore from "./components/trustpilot-score/trustpilot-score";
import UnderstandCarFinance from "./components/understand-car-finance/understand-car-finance";
import CarFinanceHead from "./components/head/head";
import { carFinancePageText } from "./locales/index";
import { useTrustpilotScore } from "@cinch-nx/data-trustpilot";
import { Env, readFromEnv } from "@cinch-nx/environments";
import { TrustpilotScoreless } from "@cinch-nx/shared-ui";
import styles from "./feature-car-finance.module.css";
export function FeatureCarFinance({ trustpilotData  }) {
    const findACarRef = useRef(null);
    const cinchStarRating = useTrustpilotScore();
    const showTrustPilotScoreless = readFromEnv(Env.ShowScorelessTrustpilot) === "true";
    const showTruspilotScoreless = cinchStarRating ? showTrustPilotScoreless || cinchStarRating <= 4.2 : showTrustPilotScoreless;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(CarFinanceHead, {
                fallbackTitle: carFinancePageText.carFinanceHeadText.fallbackTitle,
                fallbackDescription: carFinancePageText.carFinanceHeadText.fallbackDescription
            }),
            /*#__PURE__*/ _jsx(FindACarCta, {
                i18n: carFinancePageText.findACarCta,
                triggerPointRef: findACarRef
            }),
            trustpilotData && /*#__PURE__*/ _jsx("div", {
                className: styles.trustPilotWrapper,
                children: showTruspilotScoreless ? /*#__PURE__*/ _jsx(TrustpilotScoreless, {
                    shouldShowFirstLine: false,
                    numberOfReviews: trustpilotData.totalReviews
                }) : /*#__PURE__*/ _jsx(TrustpilotScore, {
                    numberOfReviews: trustpilotData.totalReviews,
                    starRatingLabel: trustpilotData.starRatingLabel,
                    starRating: trustpilotData.starRating
                })
            }),
            /*#__PURE__*/ _jsx(HowItWorks, {
                i18n: carFinancePageText.howItWorks
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: findACarRef,
                children: /*#__PURE__*/ _jsx(FindACar, {
                    i18n: carFinancePageText.findACar
                })
            }),
            /*#__PURE__*/ _jsx(FinanceExplained, {
                i18n: carFinancePageText.financeExplained
            }),
            /*#__PURE__*/ _jsx(UnderstandCarFinance, {
                i18n: carFinancePageText.understandCarFinance
            }),
            /*#__PURE__*/ _jsx(FinanceLenders, {
                i18n: carFinancePageText.lenderPartners
            }),
            /*#__PURE__*/ _jsx(ReadyToGetCarFinance, {
                i18n: carFinancePageText.readyToGetCarFinance
            })
        ]
    });
}
export default FeatureCarFinance;
